import { configureStore } from '@reduxjs/toolkit';
import uiSlice from './ui';
import settings from './settings';

const store = configureStore({
    reducer: {
        ui: uiSlice.reducer,
        settings: settings.reducer
    }
})

export default store;